module.exports = __webpack_public_path__ + "img/g7.12d0ae40.jpg";